// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__3WALC","infoBtn":"quickbooks_infoBtn__sWhF2","formBox":"quickbooks_formBox__1l7IT","formFooter":"quickbooks_formFooter__tgC08"};